import React, { useEffect, useState } from 'react';
import { api } from '../utils/api';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

function LoadingSpinner() {
  return (
    <div className="flex justify-center items-center p-8">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
    </div>
  );
}

export function ConnectEbayAccount() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get('code');

    if (!code) {
      setError('Missing authorization code. Start the connection from the Shops page.');
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    api.post('/ebay/exchange-code-for-token', {
      code,
      lang: 'FR',
    })
      .then(() => {
        toast.success('Ebay shop connected successfully');
        navigate('/shops');
      })
      .catch((err) => {
        setError(err.message);
        toast.error('Error exchanging code for token');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [navigate, searchParams]);

  if (error) {
    return (
      <div className="flex pt-10 justify-center items-start min-h-screen">
        <div className="text-center p-8 rounded-lg bg-red-50 border border-red-100">
          <h2 className="text-lg font-semibold text-red-800 mb-2">Connection Failed</h2>
          <p className="text-red-600 mb-4">{error}</p>
          <button
            onClick={() => navigate('/shops')}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Back to Shops
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex pt-10 justify-center items-start min-h-screen">
      <div className="text-center">
        <LoadingSpinner />
        <p className="mt-4 text-gray-600">Connecting to Ebay...</p>
      </div>
    </div>
  );
}

export default ConnectEbayAccount;
